import React from 'react'
import X5_A from '../../../assets/X5/X5-A.png'
import X5Model from '../../../components/X5Model'
import { Button, Table, Modal, Tooltip } from 'antd'
import { fetchGoodsDetails } from '../../../api/business'
import Headers from '../../../components/Headers'

import './index.scss'
const BreadCrumbData = [
  { path: '/page/business/business', name: '运营商管理' },
  { path: '/page/business/business', name: '运营商管理' },
  { path: '/page/business/business', name: '查看点位' },
  { path: '/page/business/business', name: '查看商品投放详情' },
]
class X5Equipment extends React.Component {
  state = {
    currentArea: 'X5_A',
    currentImg: X5_A,
    currentRow: 1,
    totalRow: 8,
    X5Data: {},
    bigImgUrl: '',
    bigImgVisible: false,
  }
  toggleArea = (imgUrl, value) => {
    const { X5Data } = this.state
    this.setState({
      currentArea: value,
      currentRow: 1,
      currentImg: imgUrl,
      totalRow: X5Data[value] ? X5Data[value].length : 8,
    })
  }
  componentDidMount() {
    this.getList()
    console.log(this.props.match.params.id)
  }
  getList = () => {
    fetchGoodsDetails({ pointId: this.props.match.params.id }).then((res) => {
      if (res.success && res.data.columnList) {
        let X5Data = {
          X5_A: [],
          X5_B: [],
          X5_C: [],
          X5_D: [],
          X5_E: [],
          X5_F: [],
        }
        res.data.columnList.forEach((item, index) => {
          item.aisleList.forEach((item1, index1) => {
            item1.type = item1.aisleType
            item1.col = item1.aisleNo
            item1.checked = false
          })

          if (index < 8) {
            X5Data.X5_A.push({
              checked: false,
              row: index + 1,

              aisleList: item.aisleList,
            })
          } else if (index < 16) {
            X5Data.X5_B.push({
              checked: false,
              row: index + 1,

              aisleList: item.aisleList,
            })
          } else if (index < 24) {
            X5Data.X5_C.push({
              checked: false,
              row: index + 1,

              aisleList: item.aisleList,
            })
          } else if (index < 27) {
            X5Data.X5_D.push({
              checked: false,
              row: index + 1,

              aisleList: item.aisleList,
            })
          } else if (index < 30) {
            X5Data.X5_E.push({
              checked: false,
              row: index + 1,

              aisleList: item.aisleList,
            })
          } else if (index < 33) {
            X5Data.X5_F.push({
              checked: false,
              row: index + 1,

              aisleList: item.aisleList,
            })
          }
        })
        this.setState({
          X5Data,
          totalRow: X5Data[this.state.currentArea].length,
        })
      }
    })
  }
  renderType = (value) => {
    switch (value) {
      case 'ROTATES':
        return '旋转'
    }
  }

  renderRow = () => {
    const { totalRow, currentRow, currentArea } = this.state
    let temp = []
    let defaultNum = 0
    switch (currentArea) {
      case 'X5_A':
        defaultNum = 0
        break
      case 'X5_B':
        defaultNum = 8
        break
      case 'X5_C':
        defaultNum = 16
        break
      case 'X5_D':
        defaultNum = 24
        break
      case 'X5_E':
        defaultNum = 27
        break
      case 'X5_F':
        defaultNum = 30
        break
      default:
        break
    }
    for (let i = 0; i < totalRow; i++) {
      temp.push(i + 1 + defaultNum)
    }
    return temp.map((item, index) => {
      return (
        <Button
          key={index}
          type={index + 1 === currentRow ? 'primary' : 'normal'}
          onClick={() => this.chooseRow(index + 1)}>
          第{item}列
        </Button>
      )
    })
  }
  chooseRow = (value) => {
    this.setState({
      currentRow: value,
    })
  }
  renderImg = (text) => {
    return (
      <img
        onClick={() => this.showBigImg(text)}
        style={{ width: 40, height: 40, cursor: 'pointer' }}
        src={text}></img>
    )
  }
  showBigImg = (url) => {
    this.setState({
      bigImgVisible: true,
      bigImgUrl: url,
    })
  }
  render() {
    const { currentArea, X5Data, currentImg, currentRow } = this.state
    return (
      <div className='container'>
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <Button
          style={{
            margin: '24px 0 16px 24px',
          }}
          onClick={() => this.props.history.goBack()}>
          返回
        </Button>
        <div className='X5Container'>
          <div className='left'>
            <X5Model
              currentImg={currentImg}
              toggleArea={this.toggleArea}></X5Model>
            <div className='title'>点击切换转盘</div>
            <div className='rowList'> {this.renderRow()}</div>
          </div>
          <div className='right'>
            <Table
              hasBorder={false}
              pagination={false}
              rowKey='aisleNo'
              dataSource={
                X5Data[currentArea]
                  ? X5Data[currentArea][currentRow - 1].aisleList
                  : []
              }>
              <Table.Column title='货道号' dataIndex='aisleNo' />
              <Table.Column
                title='品牌名称'
                dataIndex='brandName'
                // cell={this.renderType}
              />
              <Table.Column title='商品名称' dataIndex='materialsName' />
              <Table.Column title='商品编码' dataIndex='code' />
              <Table.Column title='商品售价/元' dataIndex='price' />
              <Table.Column title='条形码' dataIndex='barCode' />
              <Table.Column
                title='商品图片'
                dataIndex='pic'
                render={this.renderImg}
              />
              <Table.Column
                title='测评维度'
                width={170}
                render={(text) => {
                  let str = ''
                  text.forEach((item, index) => {
                    str += item + (index == text.length - 1 ? '' : '、')
                  })
                  return (
                    <Tooltip title={str}>
                      <div
                        style={{
                          width: 170,
                        }}
                        className='one-text-cut'>
                        {str}
                      </div>
                    </Tooltip>
                  )
                }}
                dataIndex='dimension'
              />
            </Table>
          </div>
        </div>
        <Modal
          title='图片预览'
          onCancel={() => this.setState({ bigImgVisible: false })}
          visible={this.state.bigImgVisible}
          footer={null}>
          <img
            style={{ width: '100%', height: '100%' }}
            src={this.state.bigImgUrl}></img>
        </Modal>
      </div>
    )
  }
}
export default X5Equipment
